export default __webpack_public_path__ + "static/media/glrc-course.pasta-and-sauce.40de4c2e.gif";